import type { TemplateAssociations } from "@amzn/d16-g-cdb-publisher-portal-typescript-client";
import type { Domain as CDBDomain } from "@amzn/d16-g-client-deck-builder-typescript-client";
import * as R from "remeda";

export interface Domain extends Omit<CDBDomain, "id" | "programId"> {
    id?: string | number | undefined;
    programId?: string | number | undefined;
    tags?: string[];
}

export function isTemplateInScope(
    template: TemplateAssociations,
    inputSources: string[],
    theme?: string,
    isUniversalView: boolean = false,
): boolean {
    const templateInInputSourceScope = isUniversalView
        ? // In universal view, show templates that are NOT advertiserIdScoped
          !template.domain?.metadata?.advertiserIdScoped
        : // In normal view, check if template is scoped and has matching input source
          template.domain?.metadata?.advertiserIdScoped &&
            template.domain?.metadata.advertiserIdScopedInputSource
          ? inputSources.includes(
                template.domain.metadata.advertiserIdScopedInputSource,
            )
          : true;

    const templateInThemeScope =
        !theme ||
        (R.isNonNullish(template.program?.themes) &&
            template.program!.themes.includes(theme));

    return templateInInputSourceScope && templateInThemeScope;
}
